import axios from "axios";
import { BACKEND_URL } from "@/lib/api";

const SUB_TOKEN_KEY = "dnf_sub_token";
const SUB_CTX_KEY = "dnf_sub_ctx";

export const subApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

subApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(SUB_TOKEN_KEY);
  if (t) cfg.headers["X-Sub-Token"] = t;
  return cfg;
});

export function setSubToken(token) {
  if (token) localStorage.setItem(SUB_TOKEN_KEY, token);
  else localStorage.removeItem(SUB_TOKEN_KEY);
}

export function setSubContext(ctx) {
  if (ctx) localStorage.setItem(SUB_CTX_KEY, JSON.stringify(ctx));
  else localStorage.removeItem(SUB_CTX_KEY);
}

export function getSubContext() {
  try { return JSON.parse(localStorage.getItem(SUB_CTX_KEY) || "null"); } catch { return null; }
}
